import { useEffect, useState } from 'react';
import CustomAppBar from '../../components/CustomAppBar';
import { alpha, Box, Button, Card, CircularProgress, Container, darken, Fab, Grid, IconButton, ImageList, ImageListItem, lighten, LinearProgress, Typography, Divider } from "@mui/material";
import { AddIcCallOutlined, Close, CloseOutlined, GraphicEq, PlayArrow, PlayArrowOutlined, PlayArrowRounded, StarBorderOutlined } from '@mui/icons-material';
import { connect, useDispatch } from 'react-redux';
import { authActions } from '../../store/reducer/auth-reducer';
import { homePageActions } from '../../store/reducer/home';
import { starlineActions } from '../../store/reducer/starline';
import { useNavigate } from 'react-router-dom';
import AlertBar from '../../components/AlertBar';
import { Call, Telegram, WhatsApp } from "@mui/icons-material";
import { ReactComponent as StarGameIcon } from '../../assets/star-fall-svgrepo-com.svg';
import { ReactComponent as PlayIcon } from '../../assets/play-square-svgrepo-com.svg';
import { ReactComponent as TimerIcon } from '../../assets/timer-start-svgrepo-com.svg';
import { ReactComponent as ContactUs } from '../../assets/support-svgrepo-com.svg';
import { ReactComponent as AddFundIcon } from '../../assets/wallet-receive-svgrepo-com.svg';
import { ReactComponent as WithdrawFundIcon } from '../../assets/wallet-send-svgrepo-com.svg';
import { ReactComponent as InfoIcon } from '../../assets/info-square-svgrepo-com.svg';
import AddIcon from '@mui/icons-material/Add';
import CustomModal from '../../components/CustomModal';

import { ReactComponent as OpenIcon } from '../../assets/check-square-svgrepo-com.svg';
import { ReactComponent as CloseIcon } from '../../assets/close-square-svgrepo-com.svg';
import { get, isEmpty } from 'lodash';
import DocumentTitle from '../../components/DocumentTitle';
import { useAddToHomescreenPrompt } from '../../components/useAddToHomescreenPrompt';
import { ReactComponent as Logo } from '../../assets/logo.svg';


const AppHome = ({ homePageData, isHomeLoading, sliderData, isCheckGameStatusLoading, gameStatusData, isCheckGameStatusFailed, isCheckGameStatusSuccess, contactData, walletBalance, userData, isStarLineLoading, starLineData }: any) => {
    const userDataSession: any = localStorage.getItem('userData');
    const finalData = JSON.parse(userDataSession)
    const [pageData, setPageData] = useState<any>([])
    const [starlineGames, setStarlineGames] = useState<any>([])
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState<any>({ status: false, message: '', severity: '', inputName: '' })
    const [selectedItem, setSelectedItem] = useState<any>({});
    const [openModal, setOpenModal] = useState<any>(false);

    const [prompt, promptToInstall] = useAddToHomescreenPrompt();
    const [isVisible, setVisibleState] = useState(false);

    const hide = () => setVisibleState(false);

    useEffect(
        () => {
            if (prompt) {
                setVisibleState(true);
            }
        },
        [prompt]
    );

    useEffect(() => {
        const data: any = {
            app_key: "@34Y@#8deepmatka",
            user_id: 0,
            player_id: 0
        };
        dispatch(homePageActions.dashboardDataRequest(data))
        dispatch(homePageActions.sliderDataRequest(data))
        const datacon: any = { "app_key": "@34Y@#8deepmatka" }
        dispatch(homePageActions.contactDataRequest(datacon))
        
        // Fetch Starline games
        const starlineData: any = {
            app_key: "@34Y@#8deepmatka",
        };
        dispatch(starlineActions.starLineDataReq(starlineData))
        
        document.title = 'Home Page';
        const pay: any = {
            menuname: 'home'
        }
        dispatch(homePageActions.selectedMenu(pay))

    }, [])

    useEffect(() => {
        if (Object.keys(homePageData).length) {
            setPageData(homePageData.result)
        }
    }, [homePageData, isHomeLoading])

    useEffect(() => {
        if (!isEmpty(starLineData) && starLineData.result) {
            setStarlineGames(starLineData.result)
        }
    }, [starLineData, isStarLineLoading])

    const handleRegularGameClick = (event: any, item: any) => {
        setSelectedItem(item);
        if (item.msg_status === 1) {
            navigate('/play-game/place-bid/' + item.game_id + '/' + item.game_name)
        } else {
            setErrorMessage({ status: true, message: "Game is closed for today.", severity: 'error', inputName: '' })
        }
    }

    const handleStarlineGameClick = (event: any, item: any) => {
        setSelectedItem(item);
        if (item.msg_status === 1) {
            navigate('/starline/game-list/' + item.game_id)
        } else {
            setErrorMessage({ status: true, message: "Game is closed for today.", severity: 'error', inputName: '' })
        }
    }

    const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setErrorMessage({ status: false, message: "", severity: "", inputName: '' })
    };

    const openPopup = () => {
        setOpenModal(true)
    }


    const closePopup = () => {
        setOpenModal(false)
    }

    const openLoginCheckPages = (type: any) => {
        if (isEmpty(finalData)) {
            setErrorMessage({ status: true, message: "Login required.", severity: "warning", inputName: '' })
        } else {
            if (type === 'addpoints') {
                navigate('/add-point')
            } else {
                navigate('/withdraw-points')
            }
        }

    }

    // const colorList: any = {
    //     1: '#ffce85', 2: '#fb9090', 3: '#dcdcf9', 4: '#69b9f9', 5: '#61cdc3', 6: '#ffdacc', 7: '#fbbfa8', 8: '#f9b69c', 9: '#d9efff', 10: '#cae7fb', 11: '#b9e2fd', 12: '#fbe5ff', 13: '#fae0ff', 14: '#f8d5ff', 15: '',
    // }

    const colorList: any = {
        1: '#f7ae2b', 2: '#fb9090', 3: '#dcdcf9', 4: '#69b9f9', 5: '#61cdc3', 6: '#ffdacc', 7: '#ffdacc', 8: '#ffdacc', 9: '#ffdacc', 10: '#ffdacc', 11: '#ffdacc', 12: '#ffdacc', 13: '#ffdacc', 14: '#ffdacc', 15: '',
    }
    const fabStyle = {
        position: 'absolute',
        bottom: 80,
        right: 27,
        // width: '115px',
        // height: '79px',
        // display: 'flex',
        // flexDirection: 'column',
        // fontSize: '11px',
        // padding: '15px'
    };

    const handleLogout: any = () => {
        localStorage.removeItem('isAuthenticated');
        localStorage.removeItem('userData');
        dispatch(authActions.resetUserData());
        navigate('/');
    }


    return (
        <div>
            <Container sx={{ paddingLeft: '0px !important', paddingRight: '0px !important', marginTop: '0px !important', backgroundColor: '#F5F9FC' }}>
                {isHomeLoading ? <div style={{ width: '100%', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}> <CircularProgress /> </div> :
                    <Container sx={{ paddingLeft: '0px !important', paddingRight: '0px !important', paddingTop: '0px !important', height: 'calc(100vh - 150px)', overflowY: 'scroll', marginBottom: '70px' }} >
                        
                        {/* Starline Games Section */}
                        {starlineGames.length > 0 && (
                            <Box sx={{ padding: '10px', marginBottom: '20px' }}>
                                <Typography sx={{ 
                                    fontSize: '1.75rem', 
                                    fontWeight: '700', 
                                    color: '#4A90E2', 
                                    marginBottom: '20px',
                                    textAlign: 'center',
                                    fontFamily: 'Poppins',
                                    background: 'linear-gradient(135deg, #4A90E2 0%, #87CEEB 100%)',
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent',
                                    letterSpacing: '0.5px',
                                }}>
                                    ⭐ Starline Games
                                </Typography>
                                <Grid container sx={{ display: 'flex', justifyContent: 'flex-start', padding: '5px' }}>
                                    {starlineGames.map((item: any, index: number) => (
                                        <Grid xs={12} lg={3} md={4} sm={4} margin={1} key={`starline-${index}`}>
                                            <Card variant="outlined"
                                                onClick={(event: any) => handleStarlineGameClick(event, item)}
                                                sx={{
                                                    borderRadius: '20px',
                                                    boxShadow: '0 4px 20px rgba(74, 144, 226, 0.12)',
                                                    border: '1px solid #E8EDF2',
                                                    padding: '20px',
                                                    backgroundColor: '#FFFFFF',
                                                    cursor: 'pointer',
                                                    position: 'relative',
                                                    overflow: 'hidden',
                                                    '&::before': {
                                                        content: '""',
                                                        position: 'absolute',
                                                        top: 0,
                                                        left: 0,
                                                        right: 0,
                                                        height: '4px',
                                                        background: 'linear-gradient(90deg, #4A90E2 0%, #87CEEB 100%)',
                                                        opacity: 0,
                                                        transition: 'opacity 0.3s ease',
                                                    },
                                                    '&:hover': {
                                                        transform: 'translateY(-6px)',
                                                        boxShadow: '0 8px 30px rgba(74, 144, 226, 0.2)',
                                                        borderColor: '#6BA3E8',
                                                        '&::before': {
                                                            opacity: 1,
                                                        },
                                                    },
                                                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                                }}>
                                                <Box sx={{ 
                                                    display: 'flex', 
                                                    color: '#2C3E50', 
                                                    padding: '5px', 
                                                    flexDirection: 'row', 
                                                    justifyContent: 'space-between', 
                                                    alignItems: 'center' 
                                                }}>
                                                    <Box sx={{ display: 'flex', flexDirection: 'column', padding: '0px 8px 0px 8px', alignItems: 'flex-start', justifyContent: 'flex-start' }}>
                                                        <Typography sx={{ textAlign: 'center', color: '#2C3E50', fontFamily: 'Poppins', fontSize: '1.8rem', fontWeight: '800', lineHeight: 1 }}>
                                                            {item.game_name}
                                                        </Typography>
                                                        <Box sx={{ marginTop: '8px', display: 'flex', flexDirection: 'row', paddingLeft: '5px', alignItems: 'center', justifyContent: 'center' }}>
                                                            <Typography sx={{ 
                                                                color: '#4A90E2', 
                                                                fontFamily: 'Poppins', 
                                                                fontSize: '1.3rem', 
                                                                fontWeight: '700', 
                                                                lineHeight: 1,
                                                                letterSpacing: '2px',
                                                                background: 'linear-gradient(135deg, #4A90E2 0%, #87CEEB 100%)',
                                                                WebkitBackgroundClip: 'text',
                                                                WebkitTextFillColor: 'transparent',
                                                            }}>
                                                                {(item.open_result != '') ? item.open_result : '***-*'}
                                                            </Typography>
                                                        </Box>
                                                        <Box sx={{ marginTop: '8px', display: 'flex', flexDirection: 'row', paddingLeft: '5px', alignItems: 'center', justifyContent: 'center' }}>
                                                            <Typography sx={{ color: '#5D6D7E', fontFamily: 'Poppins', fontSize: '0.85rem', fontWeight: '500', lineHeight: 1 }}>
                                                                Result Time: {item.open_time}
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                    <IconButton sx={{
                                                        borderRadius: '18px', height: '100px', width: '100px', padding: 0,
                                                        display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', boxShadow: '0px 0px 0px #adadad27'
                                                    }}>
                                                        {(item.msg_status === 1) ? 
                                                            <Typography sx={{ fontSize: '9px', color: 'green', marginBottom: '5px', fontWeight: 'bold' }}>OPEN</Typography> : 
                                                            <Typography sx={{ fontSize: '8px', color: 'red', marginBottom: '2px', fontWeight: 'bold' }}>Closed for today</Typography>
                                                        }
                                                        <Box sx={{ 
                                                            display: 'flex', 
                                                            justifyContent: 'center', 
                                                            alignItems: 'center', 
                                                            height: '55px', 
                                                            width: '55px', 
                                                            borderRadius: '16px', 
                                                            background: 'linear-gradient(135deg, #4A90E2 0%, #87CEEB 100%)',
                                                            boxShadow: '0 4px 15px rgba(74, 144, 226, 0.3)',
                                                            transition: 'all 0.3s ease',
                                                        }}>
                                                            <PlayArrowRounded sx={{ fontSize: '2.2rem', color: '#FFFFFF' }} /> 
                                                        </Box>
                                                        <Typography sx={{ fontSize: '8px', color: '#5d5d5d', marginBottom: '0px', marginTop: '5px' }}>Play game</Typography>
                                                    </IconButton>
                                                </Box>
                                            </Card>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Box>
                        )}

                        {/* Divider between sections */}
                        {starlineGames.length > 0 && pageData.length > 0 && (
                            <Divider sx={{ margin: '20px 10px', borderWidth: '2px', borderColor: '#f7ae2b' }} />
                        )}

                        {/* Regulars Games Section */}
                        {pageData.length > 0 && (
                            <Box sx={{ padding: '10px' }}>
                                <Typography sx={{ 
                                    fontSize: '1.5rem', 
                                    fontWeight: 'bold', 
                                    color: '#333', 
                                    marginBottom: '15px',
                                    textAlign: 'center'
                                }}>
                                    🎮 Regulars Games
                                </Typography>
                                <Grid container sx={{
                                    display: 'flex', justifyContent: 'flex-start', padding: '5px', marginBottom: {
                                        xs: '45px',
                                        lg: 0,
                                        md: 0,
                                        xl: 0,
                                        sm: '45px',
                                    }
                                }}>
                                    {pageData.map((item: any, index: number) => (
                                        <Grid xs={12} lg={3} md={4} sm={4} margin={1} key={`regular-${index}`}>
                                            <Card variant="outlined"
                                                onClick={(event: any) => handleRegularGameClick(event, item)}
                                        sx={{
                                            borderRadius: '22px', boxShadow: '0px 0px 2px #adadad27',
                                            border: '0px solid transparent', padding: '5px', backgroundColor: '#ffff',

                                        }}>
                                        <Box sx={{ display: 'flex', color: (item.msg_status === 1) ? '#5d5d5d' : '#5d5d5d', padding: '10px 5px 10px 5px', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>



                                            <Box sx={{ display: 'flex', flexDirection: 'column', padding: '0px 8px 0px 8px', alignItems: 'flex-start', justifyContent: 'flex-start' }}>
                                                <Box sx={{ display: 'flex', flexDirection: 'column', paddingLeft: '5px', alignItems: 'flex-start', justifyContent: 'flex-start' }}>
                                                    <Typography sx={{ textAlign: 'center', color: 'inherit', fontFamily: 'calibri', fontSize: '1.8rem', fontWeight: '800', lineHeight: 1 }}>
                                                        {item.game_name}
                                                    </Typography>
                                                    <Typography sx={{ marginTop: '5px', textAlign: 'center', color: '#f7ae2b', fontFamily: 'calibri', fontSize: '1.5rem', fontWeight: '800', lineHeight: 1 }}>
                                                        {(item.open_result != '') ? item.open_result : '***-*'}{(item.close_result != '') ? item.close_result : '*-***'}
                                                    </Typography>
                                                </Box>
                                                <Box sx={{ marginTop: '5px', display: 'flex', flexDirection: 'row', paddingLeft: '5px', alignItems: 'center', justifyContent: 'center' }}>
                                                    <Typography sx={{ color: 'inherit', fontFamily: 'calibri', fontSize: '0.8rem', fontWeight: '400', lineHeight: 1 }}>
                                                        Open Time -  Close Time
                                                    </Typography>
                                                </Box>
                                                <Box sx={{ marginTop: '5px', display: 'flex', flexDirection: 'row', paddingLeft: '5px', alignItems: 'center', justifyContent: 'center' }}>
                                                    <Typography sx={{ color: 'inherit', fontFamily: 'calibri', fontSize: '0.8rem', fontWeight: '400', lineHeight: 1 }}>
                                                        {item.open_time} -  {item.close_time}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            <IconButton sx={{
                                                borderRadius: '18px', height: '100px', width: '100px', padding: 0,
                                                display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', boxShadow: '0px 0px 0px #adadad27'
                                            }}>
                                                {(item.msg_status === 1) ? <Typography sx={{ fontSize: '8px', color: 'green', marginBottom: '5px' }}>Open</Typography> : <Typography sx={{ fontSize: '9px', color: 'red', marginBottom: '2px' }}>Closed for today</Typography>}
                                                {item.msg_status == 1 ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '40px', width: '40px', borderRadius: '30px', backgroundColor: '#f8b12a' }}><PlayArrowRounded sx={{ fontSize: '2rem' }} /> </div> : <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '40px', width: '40px', borderRadius: '30px', backgroundColor: '#f8b12a' }}><PlayArrowRounded sx={{ fontSize: '2rem' }} /> </div>}
                                                <Typography sx={{ fontSize: '8px', color: '#5d5d5d', marginBottom: '0px', marginTop: '5px' }}>Play game</Typography>
                                            </IconButton>

                                        </Box>
                                            </Card>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Box>
                        )}

                        {/* No data message */}
                        {!isHomeLoading && !isStarLineLoading && pageData.length === 0 && starlineGames.length === 0 && (
                            <Box sx={{ padding: '50px', textAlign: 'center' }}>
                                <Typography>No games available</Typography>
                            </Box>
                        )}


                    </Container>}


                <AlertBar handleClose={handleClose} errorMessage={errorMessage} />
                {/* {!isVisible ? '': <Fab sx={fabStyle} color="primary" aria-label="add" onClick={promptToInstall}>
                    <AddIcon  />                    
                </Fab>} */}

            </Container>
        </div>
    )
}

const mapStateToProps = (state: any) => ({
    homePageData: state.homepage.homePageData,
    isHomeLoading: state.homepage.isHomeLoading,
    isCheckGameStatusLoading: state.homepage.isCheckGameStatusLoading,
    gameStatusData: state.homepage.gameStatusData,
    isCheckGameStatusFailed: state.homepage.isCheckGameStatusFailed,
    isCheckGameStatusSuccess: state.homepage.isCheckGameStatusSuccess,
    sliderData: state.homepage.sliderData,
    contactData: state.homepage.contactData,
    isStarLineLoading: state.starline.isStarLineLoading,
    starLineData: state.starline.starLineData,
})


export default connect(mapStateToProps)(AppHome);